<!--
 * @Author: your name
 * @Date: 2021-04-21 15:19:27
 * @LastEditTime: 2021-08-25 17:49:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\myOrder.vue
-->

<template>
  <div class="order-box">
    <div class="order-item">
      <div class="item-main">
        <!-- 订单头部区 -->
        <div class="code flex-b">
          <div class="order-head-left">
            <img
              class="order-icon"
              v-if="orderInfo.order_type!=0&&orderInfo.order_type!=5"
              :src="orderInfo.order_type==1?imgPath+'yj_present2.png':(orderInfo.order_type==2||orderInfo.order_type==3||orderInfo.order_type==4)?imgPath+'tihuo3.png':''"
            />
            <span
              class="order_no"
            >订单编号:{{ (orderInfo.order_status == 0 || orderInfo.order_status == -1) ? orderInfo.order_no : orderInfo.chain_order_sn}}</span>
          </div>
          <div
            class="order-state"
          >{{orderInfo.order_status==-1?'已取消':orderInfo.order_status==0?'待付款':orderInfo.order_status==1?'待发货':orderInfo.order_status==2?'待收货':orderInfo.order_status==3?'已完成':orderInfo.order_status==4?'退款中':'退款审核成功'}}</div>
        </div>
        <!-- 订单头部区结束 -->
        <!-- 订单商品区 -->
        <div
          class="shop-main flex"
          @click="toOrderDetail(orderInfo.order_no,orderInfo.id,orderInfo.id)"
          v-for="item in orderInfo.child_list"
          :key="item.id"
        >
          <img :src="item.goods_image?item.goods_image:imgPath+'yj_defatult.png'" />
          <div class="shop-item">
            <div class="shop-name ellipsis">{{item.goods_name}}</div>
            <div class="shop-spec">规格:{{item.sku_name}}</div>
            <b>x{{item.num}}</b>
            <div
              class="shop-price"
              v-if="item.is_mz == 0"
            >¥{{ (orderInfo.order_type == 1 || orderInfo.order_type == 9) ? item.market_price_dollar :item.goods_price_dollar}}</div>
            <div class="shop-price" v-else>赠品</div>
          </div>
        </div>
        <!-- {{orderInfo.total += item.num}} -->
      </div>

      <!-- 订单商品区结束 -->
      <!-- 订单结算区 -->
      <div class="item-total">
        共 {{orderInfo.total}} 件商品，总计：
        <span
          class="goods-amount-dollar"
        >¥{{ orderInfo.order_type == 1 ? orderInfo.goods_market_all_money : orderInfo.pay_money_dollar}}</span>
      </div>
      <div class="order-btn" v-if="orderInfo.order_status == 0 || orderInfo.order_status ==2">
        <div
          class="to-pay"
          @click.stop="payGoods(orderInfo.id,orderInfo.order_status,orderInfo.order_no,orderInfo.pay_money_dollar,orderInfo.shipping_money_dollar,orderInfo.parent_order_id,orderInfo.transfer_ids,orderInfo.order_type
)"
        >
          <span class="to-pay-text">{{orderInfo.order_status ==2 ?'确认收货':'去支付'}}</span>
        </div>
        <div
          class="cancel-pay"
          v-if="orderInfo.order_status !=2"
          @click.stop="cancelOrder(orderInfo.parent_order_id)"
        >取消订单</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderItem',
  props: {
    orderInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    // 进入订单详情
    toOrderDetail(order_no, order_id, id) {
      this.$emit('toOrderDetail', order_no, order_id, id)
    },
    // 去支付
    async payGoods(
      id,
      order_status,
      order_no,
      order_money_dollar,
      shipping_money_dollar,
      parent_order_id,
      transfer_ids,
      order_type
    ) {
      this.$emit(
        'orderPay',
        id,
        order_status,
        order_no,
        order_money_dollar,
        shipping_money_dollar,
        parent_order_id,
        transfer_ids,
        order_type
      )
    },
    // 取消订单
    async cancelOrder(id) {
      this.$emit('cancelOrder', id)
    },
  },
  created() {
    console.log(this.orderInfo['order_status'])
  },
  mounted() {
    this.prohibitweixinShare()
  },
  computed: {
    // orderStatus () {
    //   switch (this.orderInfo['order_status']) {
    //     case '-1':
    //       return '已取消';
    //     case '0':
    //       return '待付款';
    //     case '1':
    //       return '待发货';
    //     case '2':
    //       return '待收货';
    //     case '3':
    //       return '已完成';
    //     case '4':
    //       return '退款中';
    //     case '5':
    //       return '退款审核成功';
    //   }
    // },
    childOrderList() {
      return this.orderInfo['child_order_list']
    },
  },
}
</script>
<style lang="scss" scoped>
.order-item {
  width: 710px;
  background: #fff;
  border-radius: 14px;
  display: block;
  margin-top: 20px;
  padding-bottom: 30px;
  .code {
    padding: 23px 30px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #eeeeee;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
    line-height: 37px;
    .order-head-left {
      display: flex;
      align-items: center;
      .order-icon {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-right: 9px;
      }
      .order-no {
        height: 37px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 37px;
      }
    }
    .order-state {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #f0240e;
      line-height: 37px;
    }
  }
  .shop-main {
    padding: 21px 30px 0 30px;
    box-sizing: border-box;
    img {
      width: 140px;
      height: 140px;
      display: block;
      margin-right: 30px;
      border-radius: 10px;
      border: 1px solid #eee;
    }
    .shop-item {
      .shop-name {
        width: 420px;
        font-size: 28px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #333333;
        padding: 10px 0;
      }
      b {
        font-size: 24px;
        padding-left: 10px;
        color: #999;
      }
      .shop-spec {
        padding: 0 13px;
        background: #f2f2f2;
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        color: #999999;
        line-height: 33px;
        margin-top: 15px;
        display: inline-block;
      }
      .shop-price {
        font-size: 34px;
        font-weight: 600;
        color: #f0240e;
        line-height: 34px;
        margin-top: 26px;
      }
    }
  }

  .item-total {
    font-size: 26px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #343434;
    line-height: 30px;
    margin-top: 22px;
    text-align: right;
    .total-text {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #343434;
      line-height: 26px;
      margin-right: 18px;
    }
    .goods-amount-dollar {
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
      margin-right: 20px;
    }
  }
  .order-btn {
    display: flex;
    flex-flow: row-reverse;
    width: 100%;
    margin-top: 40px;
    > div {
      width: 200px;
      height: 68px;
      text-align: center;
      border-radius: 34px;
      font-weight: 400;
      color: #323233;
      line-height: 64px;
      margin-right: 20px;
    }

    > .to-pay {
      background: #ee0a24;
      .to-pay-text {
        color: #fff;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 42px;
      }
    }
    .cancel-pay {
      box-sizing: border-box;
      border: 2px solid #dcdee0;
      background-color: #fff;
      .cancel-pay-text {
        color: #323233;
        font-size: 28px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 40px;
      }
    }
  }
}

.data-none {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: #fff;
  img {
    width: 320px;
    height: 320px;
    display: block;
    margin: 150px auto;
  }
  .order-sile {
    text-align: center;
    font-weight: 400;
    color: #969799;
    line-height: 28px;
    text-align: center;
    .order-size {
      font-weight: 500;
      color: #666666;
      line-height: 28px;
      margin: 40px 0 32px;
    }
  }
}
</style>